import Color from '../Color.mjs'
import superMeta from '../_ARCH/metaArchNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_ORANGE,
    alias: '分析模型',
    archName: '分析地图',
    archUrl: '/ProjectAnaMap',
    detailUrl: '/AaDetail',
    detailIdProp: 'aaId',
    listUrl: '/AaList',
    mapProp: 'aaMap',
    moduleType: 'AM',
    name: '分析结构',
    type: 'AA',
}
